<template>
  <div class="study">
    <Banner :list="banners" :myHeight="460" :hadFrom="true"></Banner>
    <div class="study-main container">
      <div class="introduction">
        <div class="img-box">
          <img src="@/assets/image/study/1.png" alt="" />
        </div>
        <div class="info">
          <div class="title">
            <h3 class="sname">INTRODUCTION</h3>
            <h3 class="name">学院简介</h3>
          </div>
          <p class="desc my-5">
            优普道网校是优普道集团旗下，开发的移动互联网职业教育一站式服务平台。凭借着优普道集团
            深耕建筑咨询行业的优势，深刻了解到人才培训教育对建筑企业的重要性。在建筑职业教育领域
            纵深发展，为建筑企业培养出符合发展战略的优质人才！
          </p>
          <div class="btn">
            <a-button class="mr-2" type="primary" @click="$toConnectLink">
              立即质询
            </a-button>
            <a-button @click="$toConnectLink"> 了解详情>> </a-button>
          </div>
        </div>
      </div>
      <div class="lesson">
        <div class="main-title">
          <h1>完善的建工课程体系</h1>
          <h3>助力企业内部孵化 打造企业内部核心团队</h3>
        </div>
        <div class="lesson-main">
          <template v-for="(item, index) in lessonList">
            <div class="item" :key="index" @click="$toConnectLink">
              <img :src="item.img" alt="" />
              <p class="mt-3">{{ item.name }}</p>
            </div>
          </template>
        </div>
      </div>
      <!-- 试听 -->
      <div class="audition" v-if="false">
        <div class="main-title">
          <h1>名师课程免费体验</h1>
          <h3>搭建企业人才平台 为行业健康发展助力</h3>
        </div>
        <div class="audition-main">
          <div class="audition-menu">
            <template v-for="(item, index) in auditionList">
              <div
                class="item pl-5"
                @click="changeAudition(index)"
                :class="{ active: index == auditionActive }"
                :key="index"
              >
                {{ item.name }}
              </div>
            </template>
          </div>
          <div class="audition-content p-2">
            <div class="video-box">
              <video
                class="myVideo"
                :src="nowVideo"
                type="video/mp4"
                autoplay="autoplay"
                preload="none"
                controls="controls"
                playsinline="true"
                webkit-playsinline="true"
                x5-playsinline="true"
                x5-video-player-type="h5"
                style="object-fit: fill; display: inline"
              ></video>
            </div>
            <div class="video-list">
              <template
                v-for="(item, index) in auditionList[auditionActive].videoList"
              >
                <div
                  class="item"
                  :key="index"
                  :class="{ active: item == nowVideo }"
                  @click="changeVideo(item)"
                >
                  <video class="min-video" :src="item"></video>
                  <div class="bg-gray"></div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="teacher">
        <div class="main-title">
          <h1>名师团队</h1>
          <h3>全国一线名师 倾力打造品牌建工课程</h3>
        </div>
        <div class="teacher-main">
          <div class="teacher-container swiper-container">
            <div class="swiper-wrapper">
              <template v-for="(item, index) in teacherList">
                <div class="swiper-slide teacher-slide" :key="index">
                  <div class="teacher-content">
                    <div class="img-box">
                      <img :src="item.teacherImg" alt="" />
                    </div>
                    <div class="info">
                      <h3 class="name mr-1">{{ item.name }}</h3>
                      <p class="sname">{{ item.sname }}</p>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
          </div>
        </div>
      </div>
      <div class="mode">
        <div class="main-title">
          <h1>建工行业一站式学习平台</h1>
          <h3>直播+录播+面授，专业打造智能学习链</h3>
        </div>
        <div class="mode-main">
          <ul>
            <li
              tabindex="1"
              @mouseover="selectStyle(0)"
              :class="{ active: modeActive == 0 }"
            >
              <div>
                <a href="javaScript:;">
                  <div class="info">
                    <div class="title">
                      <h3 class="name">高清网课</h3>
                      <p class="sname">Recorded Course</p>
                    </div>
                    <div class="desc">
                      名师授课，渐进式教学，层层递进，导学+精讲+冲刺串讲，梳理要点，预测考点，高效学习，助力学员顺利通关。
                    </div>
                  </div>
                </a>
                <div class="min-title">
                  <h3 class="name">高清网课</h3>
                  <p class="sname">Recorded Course</p>
                </div>
                <img class="number" src="@/assets/image/study/12.png" alt="" />
              </div>
            </li>
            <li
              tabindex="2"
              @mouseover="selectStyle(1)"
              :class="{ active: modeActive == 1 }"
            >
              <div>
                <a href="javaScript:;">
                  <div class="info">
                    <div class="title">
                      <h3 class="name">直播课程</h3>
                      <p class="sname">Live course</p>
                    </div>
                    <div class="desc">
                      名师授课，渐进式教学，层层递进，导学+精讲+冲刺串讲，梳理要点，预测考点，高效学习，助力学员顺利通关。
                    </div>
                  </div>
                </a>
                <div class="min-title">
                  <h3 class="name">直播课程</h3>
                  <p class="sname">Live course</p>
                </div>
                <img class="number" src="@/assets/image/study/13.png" alt="" />
              </div>
            </li>
            <li
              tabindex="3"
              @mouseover="selectStyle(2)"
              :class="{ active: modeActive == 2 }"
            >
              <div>
                <a href="javaScript:;">
                  <div class="info">
                    <div class="title">
                      <h3 class="name">名师面授</h3>
                      <p class="sname">Face To Face</p>
                    </div>
                    <div class="desc">
                      线下面授课程集训强化，资深讲师精准分析考点，互动环节、讲师现场答疑解惑。针对各层次学员因材施教、大幅提升学习效率、确保教学质量
                    </div>
                  </div>
                </a>
                <div class="min-title">
                  <h3 class="name">名师面授</h3>
                  <p class="sname">Face To Face</p>
                </div>
                <img class="number" src="@/assets/image/study/14.png" alt="" />
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="download">
        <div class="main-title">
          <h1>移动端应用</h1>
        </div>
        <div class="download-main">
          <div class="download-img">
            <div class="img-box">
              <img src="@/assets/image/study/download.png" alt="" />
            </div>
            <div class="m-btn-qrcode">
              <div class="btn">
                <a-button class="ios" @click="downLoadIos">
                  <img src="@/assets/image/study/iphone.png" alt="" />
                  iPhone下载
                </a-button>
                <a-button class="android mt-2" @click="downLoadAndroid">
                  <img src="@/assets/image/study/android.png" alt="" />
                  Android下载
                </a-button>
              </div>
              <div class="qrcode">
                <div class="img-box">
                  <p>
                    <img
                      src="@/assets/image/study/appDownload.d7bbba6.png"
                      alt=""
                    />
                  </p>
                </div>
                <p class="ml-2">手机扫码下载<br />立即体验</p>
              </div>
            </div>
          </div>

          <div class="info">
            <div class="title">
              <img src="@/assets/image/study/logo.png" alt="" />
              <h3 class="ml-2">优普道网校APP</h3>
            </div>
            <p class="desc mt-3">
              优普道网校官方退出的手机端学习应用。200万学员的选择，15年建工行业教学经验保障。
              软件配合课程内容，实现掌上虚拟课堂、多维度教学模式、移动题库、讲义下载、模考系
              统、在线答疑等。
            </p>
            <div class="btn-qrcode mt-6">
              <div class="btn">
                <a-button class="ios" @click="downLoadIos">
                  <img src="@/assets/image/study/iphone.png" alt="" />
                  iPhone下载
                </a-button>
                <a-button class="android mt-2" @click="downLoadAndroid">
                  <img src="@/assets/image/study/android.png" alt="" />
                  Android下载
                </a-button>
              </div>
              <div class="qrcode">
                <div class="img-box">
                  <p>
                    <img
                      src="@/assets/image/study/appDownload.d7bbba6.png"
                      alt=""
                    />
                  </p>
                </div>
                <p class="ml-2">手机扫码下载<br />立即体验</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/components/common/banner";
import Swiper from "swiper";
export default {
  data() {
    return {
      banners: {
        title: "一站式智能资质代办平台",
        desc: "超过<span>10万+</span>建筑企业选择的咨询平台",
        list: [require("@/assets/image/banner/4.jpg")],
      },
      auditionActive: 0,
      modeActive: 0,
      lessonList: [
        {
          name: "二级建造师",
          img: require("@/assets/image/study/lesson1.png"),
        },
        {
          name: "一级建造师",
          img: require("@/assets/image/study/lesson2.png"),
        },
        {
          name: "湖南中级工程师",
          img: require("@/assets/image/study/lesson3.png"),
        },
        {
          name: "消防设施操作员",
          img: require("@/assets/image/study/lesson4.png"),
        },
        {
          name: "BIM工程师",
          img: require("@/assets/image/study/lesson5.png"),
        },
        {
          name: "消防工程师",
          img: require("@/assets/image/study/lesson6.png"),
        },
      ],
      teacherList: [
        {
          name: "高扬",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t1.jpg"),
        },
        {
          name: "关宇",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t2.jpg"),
        },
        {
          name: "李想",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t3.jpg"),
        },
        {
          name: "王欣",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t4.jpg"),
        },
        {
          name: "吴细露",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t5.jpg"),
        },
        {
          name: "梁宝臣",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t6.jpg"),
        },
        {
          name: "周军",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t7.jpg"),
        },

        {
          name: "邵洪芳",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t8.jpg"),
        },
        {
          name: "孔健",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t9.jpg"),
        },
        {
          name: "梁静",
          sname: "一、二级建造师",
          teacherImg: require("@/assets/image/study/t10.jpg"),
        },
      ],
      auditionList: [
        {
          name: "二级建造师",
          videoList: [
            "http://1301948842.vod2.myqcloud.com/e5e420cavodcq1301948842/d99d923a5285890809745816862/f0.mp4?t=5fd2013b&exper=0&sign=d44e5ce015c331839f4f78711d137303",
            "http://1301948842.vod2.myqcloud.com/e5e420cavodcq1301948842/af9756ba5285890809599071709/f0.mp4?t=5fd1feab&exper=0&sign=f7b84e5bec612837e7c61e9198901165",
            "http://1301948842.vod2.myqcloud.com/e5e420cavodcq1301948842/d99d923a5285890809745816862/f0.mp4?t=5fd2013b&exper=0&sign=d44e5ce015c331839f4f78711d137303",
          ],
        },
        {
          name: "一级建造师",
          videoList: [
            "http://1301948842.vod2.myqcloud.com/e5e420cavodcq1301948842/af9756ba5285890809599071709/f0.mp4?t=5fd1feab&exper=0&sign=f7b84e5bec612837e7c61e9198901165",
            "http://1301948842.vod2.myqcloud.com/e5e420cavodcq1301948842/d99d923a5285890809745816862/f0.mp4?t=5fd2013b&exper=0&sign=d44e5ce015c331839f4f78711d137303",
            "http://1301948842.vod2.myqcloud.com/e5e420cavodcq1301948842/d99d923a5285890809745816862/f0.mp4?t=5fd2013b&exper=0&sign=d44e5ce015c331839f4f78711d137303",
          ],
        },
      ],
      // nowVideo: this.auditionList[0].videoList[0]
      nowVideo: "",
    };
  },
  components: {
    Banner,
  },
  methods: {
    getBannerList() {
      this.$api
        .getBannerList({
          // 10首页  20
          launchPage: 80,
          launchFacility: 10,
        })
        .then((res) => {
          this.banners.list = res.data.list;
        });
    },
    changeVideo(val) {
      this.nowVideo = val;
    },
    changeAudition(index) {
      this.auditionActive = index;
    },
    toStudy() {
      var tempwindow = window.open("_blank");
      tempwindow.location = "http://www.youpudao.cn/index";
    },
    initTeacherSwiper() {
      var teacherSwiper = new Swiper(".teacher-container", {
        loop: false,
        slidesPerView: "auto",
        spaceBetween: 6,
        slidesPerGroup: 3,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
      });
    },
    downLoadIos() {
      location.href =
        "https://apps.apple.com/cn/app/%E4%BC%98%E6%99%AE%E9%81%93%E7%BD%91%E6%A0%A1/id1532741084";
    },
    downLoadAndroid() {
      location.href =
        "http://admin.youpudao.cn/uploads/20201130/be2f07240b0f3e4b196ecc5218aa1708.apk";
    },
    selectStyle(index) {
      this.modeActive = index;
    },
  },
  mounted() {
    this.getBannerList();
    this.initTeacherSwiper();
    this.nowVideo = this.auditionList[this.auditionActive].videoList[0];
  },
};
</script>

<style lang="scss">
@import "@/assets/css/study.scss";
</style>
